import autocomplete from 'autocompleter';

/**
 * Autocomplete: View Externer Support
 * @param elementID
 * @param helperFile
 * @param buchungsdatum
 */
window.autocompleteBestandskorrekturProdukt = function(elementID, helperFile, buchungsdatum = '') {
  // input
  const input = document.getElementById(elementID);
  input.setAttribute('autocomplete', 'off');

  if ($(input).hasClass('readonly')) {
    return;
  }

  const row = $(input).closest('div.row');

  autocomplete({
    emptyMsg: LANG_STRINGS.noResults,
    minLength: 0,
    input: input,
    fetch: function(text, update) {
      text = text.toLowerCase();

      // Ajax-Call
      $.ajax({
        url: BASE_PATH + 'ajax/autocomplete/' + helperFile,
        type: 'post',
        data: {
          type: elementID,
          search: text,
          buchungsdatum: buchungsdatum,
        },
        dataType: 'json',
        success: function(data) {
          let suggestions = Array();
          $.each(data, function(i, obj) {
            let valueData = Array();
            for (let key in obj) {
              valueData[key] = obj[key];
            }

            suggestions.push({
              'label': valueData['name'],
              'value': valueData,
            });
          });

          const itemCount = suggestions.length;

          if (itemCount === 0) {
            suggestions.push({
              'label': '',
              'value': '',
            });
            update(suggestions);
          }

          update(suggestions);
        },
      });
    },
    render: function(item) {
      let div = document.createElement('div');
      $(div).addClass(item.value.zulassungsstatus_id_css);
      div.textContent = item.label;
      return div;
    },
    onSelect: function(item) {
      let label = item.label;
      let tempLabel = label.replace(/\<strong\>/gi, '');
      const temp = tempLabel.replace(/\<\/strong\>/gi, '');

      const valueData = item.value;
      const url = valueData['psm_url'];

      input.label = temp;
      input.value = temp;

      row.attr('data-psm-id', valueData.uid);
      row.attr('data-key', valueData.dataKey);
      row.find('.psm_uid').val(valueData.uid);
      row.find('.psm_parent_uid').val(valueData.parent_uid);
      row.find('.psm_archived').val(valueData.archived);
      row.find('.data_key').val(valueData.dataKey);

      // make mittel and wirkstoff readonly
      $(input).attr('readonly', 'readonly').addClass('readonly');
      $(input).attr('data-url', url);

      // Felder frei setzen
      row.find('.bestand-neu-menge ').removeAttr('readonly').removeClass('readonly');
      row.find('#mittel-bemerkung-button').removeAttr('disabled').removeClass('readonly');

      getLagerbestandBestandskorrektur(row);

      // Lagergruppen
      if (row.find('select.lagergruppen').length > 0) {
        getLagergruppenBestandskorrektur(row);
      }
    },
  });
};

/**
 * getLagerbestand
 */
window.getLagerbestandBestandskorrektur = function(row) {
  const lagerID = $('select.lagergruppen').val();
  const allRowData = Array();
  $('#table-bestandskorrektur').find('.row:not(.row-table__head)').each(function() {
    const row = $(this);

    allRowData.push({
      'psmID': row.find('input.psm_uid').val(),
      'dataKey': row.find('input.data_key').val(),
    });
  });

  if (row != null) {
    allRowData.push({
      'psmID': row.find('.psm_uid').val(),
      'dataKey': row.find('.data_key').val(),
    });
  }
  $.ajax({
    url: BASE_PATH + 'ajax/helper/lager/ajax.getLagerBestand',
    data: {
      lagergruppe_uid: lagerID,
      buchungsdatum: $('input#buchungsdatum').val(),
      buchungsdatumTime: $('input#buchungsdatum_time').val(),
      allData: allRowData,
    },
    type: 'POST',
    dataType: 'json',
    success: function(data) {
      if (data) {
        $.each(data, function(psmID, item) {
          $.each(item, function(dataKey, lagerData) {
            const psmRow = $('.modal-content').find('div.row[data-psm-id="' + psmID + '"][data-key="' + dataKey + '"]');
            psmRow.find('input.bestand-menge').val(numberFormat(lagerData.bestand, 2));
            psmRow.find('input.bestand-einheit-id').val(lagerData.einheit_uid);
            psmRow.find('input.bestand-einheit').val(lagerData.einheit);
          });
        });
      }
    },
  });
};

/**
 * Lagergruppen
 * @param row
 */
window.getLagergruppenBestandskorrektur = function(row) {
  $.ajax({
    url: BASE_PATH + 'ajax/helper/lager/ajax.getLagergruppen',
    success: function(html) {
      row.find('select.lagergruppen').html(html).removeAttr('disabled').removeAttr('readonly').removeClass('readonly').change().focus();
    },
  });
};

/**
 * Reset Mittel
 * @param element
 */
window.resetMittel = function(element) {
  const row = $(element).closest('div.modal-content').find('div.modal-body div.row');

  // Produkt leeren
  row.find('.smittel').each(function() {
    const input = $(this);
    input.removeAttr('readonly');
    input.removeClass('readonly');
    input.removeAttr('data-url');
    input.val('');
  });

  // Alle anderen Inputs leeren
  const inputsToClear = row.find('input:not(.smittel)');
  inputsToClear.each(function() {
    const input = $(this);
    input.val('');
    input.addClass('readonly').attr('readonly', 'readonly');
  });

  // Selects leeren
  row.find('select').each(function() {
    const select = $(this);
    select.find('option').remove();
    select.val('');
    select.addClass('readonly').attr('disabled', 'disabled');
  });

  row.attr('data-psm-id', '');
  row.attr('data-key', '');
  row.find('.smittel').click();
  row.find('.smittel').focus();
};

/**
 * Build Bestandskorrektur Row
 * @param json
 * @param table
 */
window.buildBestandskorrekturRow = function(json, table) {
  // Template
  let template = $('#bestandskorrektur-row').html();

  const jsonObject = JSON.parse(json);
  $.each(jsonObject, function(k, v) {
    template = template.replace(new RegExp(k, 'g'), v);
  });

  if ($(table).find('*[data-row-key="' + jsonObject.__KEY__ + '"]').length > 0) {
    $(table).find('*[data-row-key="' + jsonObject.__KEY__ + '"]').replaceWith(template);
  } else {
    $(table).append(template);
  }
};

/**
 * scrollToRowBestandskorrektur
 */
window.scrollToRowBestandskorrektur = function() {
  const psmID = findGetParameter('psmID');
  const psmKey = findGetParameter('psmKey');

  if (typeof psmID !== 'undefined' && typeof psmKey !== 'undefined') {
    const rowHighlight = $('div.row[data-psm-id="' + psmID + '"][data-psm-key="' + psmKey + '"]');
    if (rowHighlight.length > 0) {
      $('html, body').animate({
        scrollTop: rowHighlight.offset().top - 100,
      }, 200);

      rowHighlight.addClass('bg-grey');
    }
  }
};
